import React from "react";
import styles from "./GetStarted.module.css";

const GetStartedBetterLeads = ({ width = 100, height = 100 }) => {
    return (
        <svg viewBox="0 0 72 72" width={width} height={height}>
            <path
                className={styles.cls1}
                d="M35.38,70.3C15.9,70.3,0.04,54.45,0.04,34.96S15.9-0.37,35.38-0.37s35.34,15.85,35.34,35.34
	S54.87,70.3,35.38,70.3z M35.38,3.23c-17.5,0-31.74,14.24-31.74,31.74S17.88,66.7,35.38,66.7c17.5,0,31.74-14.24,31.74-31.74
	S52.88,3.23,35.38,3.23z"
            />
            <g>
                <g>
                    <g>
                        <g>
                            <path
                                className={styles.cls1}
                                d="M26.77,34.94c-3.64,0-6.6-2.96-6.6-6.6v-5.38c0-3.64,2.96-6.6,6.6-6.6s6.6,2.96,6.6,6.6v5.38
					C33.38,31.98,30.41,34.94,26.77,34.94z M26.77,17.54c-2.99,0-5.42,2.43-5.42,5.42v5.38c0,2.99,2.43,5.42,5.42,5.42
					c2.99,0,5.42-2.43,5.42-5.42v-5.38C32.19,19.97,29.76,17.54,26.77,17.54z"
                            />
                            <path
                                className={styles.cls1}
                                d="M26.77,35.54c-3.97,0-7.2-3.23-7.2-7.2v-5.38c0-3.97,3.23-7.2,7.2-7.2s7.2,3.23,7.2,7.2v5.38
					C33.98,32.31,30.75,35.54,26.77,35.54z M26.77,18.14c-2.66,0-4.82,2.16-4.82,4.82v5.38c0,2.66,2.16,4.82,4.82,4.82
					c2.66,0,4.82-2.16,4.82-4.82v-5.38C31.59,20.3,29.43,18.14,26.77,18.14z"
                            />
                        </g>
                    </g>
                    <g>
                        <g>
                            <path
                                className={styles.cls1}
                                d="M34.18,51.87H19.05c-2.58,0-4.67-2.1-4.67-4.67v-5.56c0-1.05,0.66-2.09,1.96-3.12
					c1.07-0.84,2.35-1.48,3.8-1.88l4.69-1.32c0.31-0.09,0.64,0.09,0.73,0.41c0.09,0.32-0.1,0.64-0.41,0.73l-4.69,1.32
					c-1.3,0.36-2.43,0.93-3.38,1.67c-0.69,0.54-1.51,1.36-1.51,2.19v5.56c0,1.92,1.57,3.49,3.49,3.49h15.14
					c1.92,0,3.49-1.57,3.49-3.49v-5.56c0-0.83-0.82-1.65-1.51-2.19c-0.95-0.75-2.09-1.31-3.38-1.67l-4.56-1.28
					c-0.32-0.09-0.5-0.42-0.41-0.73c0.09-0.32,0.42-0.5,0.73-0.41l4.56,1.28c1.45,0.41,2.72,1.04,3.8,1.88
					c1.3,1.02,1.96,2.07,1.96,3.12v5.56C38.86,49.77,36.76,51.87,34.18,51.87z"
                            />
                            <path
                                className={styles.cls1}
                                d="M34.18,52.47H19.05c-2.91,0-5.27-2.37-5.27-5.27v-5.56c0-1.24,0.74-2.45,2.19-3.59
					c1.14-0.89,2.48-1.56,4-1.99l4.69-1.32c0.64-0.18,1.29,0.2,1.47,0.83c0.09,0.31,0.05,0.63-0.11,0.91
					c-0.16,0.28-0.41,0.48-0.72,0.56l-4.69,1.32c-1.22,0.34-2.29,0.87-3.17,1.57c-0.81,0.64-1.28,1.27-1.28,1.72v5.56
					c0,1.59,1.3,2.89,2.89,2.89h15.14c1.59,0,2.89-1.3,2.89-2.89v-5.56c0-0.45-0.47-1.07-1.28-1.72c-0.89-0.7-1.96-1.22-3.18-1.57
					l-4.56-1.28c-0.31-0.09-0.56-0.29-0.72-0.56c-0.16-0.28-0.19-0.6-0.11-0.91c0.09-0.31,0.29-0.56,0.57-0.72
					c0.28-0.16,0.6-0.19,0.9-0.11l4.55,1.28c1.52,0.43,2.87,1.1,4,1.99c1.45,1.14,2.19,2.35,2.19,3.59v5.56
					C39.46,50.1,37.09,52.47,34.18,52.47z"
                            />
                        </g>
                    </g>
                    <g>
                        <g>
                            <path
                                className={styles.cls1}
                                d="M24.98,36.48c-0.33,0-0.59-0.27-0.59-0.59v-1.54c0-0.33,0.26-0.59,0.59-0.59c0.33,0,0.59,0.27,0.59,0.59
					v1.54C25.58,36.22,25.31,36.48,24.98,36.48z"
                            />
                            <path
                                className={styles.cls1}
                                d="M24.98,37.08c-0.66,0-1.19-0.54-1.19-1.19v-1.54c0-0.66,0.53-1.19,1.19-1.19s1.19,0.54,1.19,1.19v1.54
					C26.18,36.55,25.64,37.08,24.98,37.08z"
                            />
                        </g>
                    </g>
                    <g>
                        <g>
                            <path
                                className={styles.cls1}
                                d="M28.38,36.52c-0.33,0-0.59-0.27-0.59-0.59v-1.58c0-0.33,0.26-0.59,0.59-0.59c0.33,0,0.59,0.27,0.59,0.59
					v1.58C28.98,36.25,28.71,36.52,28.38,36.52z"
                            />
                            <path
                                className={styles.cls1}
                                d="M28.38,37.12c-0.66,0-1.19-0.53-1.19-1.19v-1.58c0-0.66,0.53-1.19,1.19-1.19c0.66,0,1.19,0.54,1.19,1.19
					v1.58C29.58,36.59,29.04,37.12,28.38,37.12z"
                            />
                        </g>
                    </g>
                    <g>
                        <g>
                            <path
                                className={styles.cls1}
                                d="M26.62,42.75c-2.27,0-4.12-2.43-4.12-5.42c0-0.34,0.02-0.68,0.07-1.01c0.05-0.32,0.35-0.55,0.67-0.5
					c0.32,0.05,0.55,0.35,0.5,0.67c-0.04,0.27-0.06,0.56-0.06,0.84c0,2.34,1.32,4.24,2.94,4.24c1.62,0,2.94-1.9,2.94-4.24
					c0-0.29-0.02-0.57-0.06-0.84c-0.05-0.32,0.18-0.62,0.5-0.67c0.32-0.05,0.62,0.18,0.67,0.5c0.05,0.33,0.07,0.67,0.07,1.01
					C30.74,40.32,28.89,42.75,26.62,42.75z"
                            />
                            <path
                                className={styles.cls1}
                                d="M26.62,43.35c-2.6,0-4.72-2.7-4.72-6.02c0-0.37,0.03-0.74,0.08-1.09c0.09-0.65,0.7-1.11,1.35-1.01
					c0.32,0.04,0.6,0.21,0.79,0.46c0.19,0.26,0.27,0.57,0.23,0.89c-0.04,0.24-0.05,0.5-0.05,0.76c0,1.97,1.07,3.64,2.34,3.64
					c1.27,0,2.34-1.67,2.34-3.64c0-0.26-0.02-0.51-0.05-0.76c-0.05-0.32,0.04-0.63,0.23-0.89c0.19-0.25,0.47-0.42,0.79-0.46
					c0.31-0.04,0.62,0.03,0.88,0.22c0.26,0.19,0.42,0.47,0.47,0.79c0.05,0.36,0.08,0.73,0.08,1.09
					C31.34,40.65,29.22,43.35,26.62,43.35z"
                            />
                        </g>
                    </g>
                    <g>
                        <g>
                            <path
                                className={styles.cls1}
                                d="M28.97,23.62c-0.75,0-1.3-0.19-1.73-0.38c-0.68-0.31-1.09-0.75-1.46-1.13c-0.36-0.38-0.62-0.66-1.06-0.76
					c-0.91-0.21-2.12,0.48-3.52,1.98c-0.22,0.24-0.6,0.25-0.84,0.03c-0.24-0.22-0.25-0.6-0.03-0.84c1.72-1.86,3.28-2.64,4.65-2.33
					c0.79,0.18,1.25,0.67,1.66,1.09c0.32,0.34,0.62,0.66,1.1,0.87c0.8,0.37,2.05,0.6,4.65-0.88c0.28-0.16,0.65-0.06,0.81,0.22
					c0.16,0.28,0.06,0.65-0.22,0.81C31.22,23.31,29.93,23.62,28.97,23.62z"
                            />
                            <path
                                className={styles.cls1}
                                d="M28.96,24.22c-0.93,0-1.57-0.25-1.98-0.44c-0.78-0.36-1.26-0.86-1.64-1.26c-0.35-0.37-0.51-0.53-0.76-0.59
					c-0.67-0.14-1.74,0.5-2.94,1.8c-0.22,0.23-0.51,0.37-0.83,0.38c-0.32,0.02-0.62-0.1-0.86-0.32c-0.23-0.21-0.37-0.51-0.38-0.82
					c-0.01-0.32,0.1-0.62,0.32-0.86c1.87-2.03,3.63-2.87,5.22-2.51c0.96,0.22,1.51,0.8,1.95,1.26c0.31,0.32,0.55,0.58,0.92,0.75
					c0.67,0.31,1.74,0.49,4.1-0.85c0.27-0.16,0.59-0.2,0.91-0.11c0.31,0.08,0.56,0.28,0.72,0.56c0.16,0.27,0.2,0.6,0.11,0.9
					c-0.08,0.31-0.28,0.56-0.56,0.72C31.63,23.77,30.22,24.22,28.96,24.22z"
                            />
                        </g>
                    </g>
                </g>
                <g>
                    <g>
                        <g>
                            <path
                                className={styles.cls1}
                                d="M41.19,29.95c-3.64,0-6.6-2.96-6.6-6.6v-5.38c0-3.64,2.96-6.6,6.6-6.6s6.6,2.96,6.6,6.6v5.38
					C47.79,26.98,44.83,29.95,41.19,29.95z M41.19,12.54c-2.99,0-5.42,2.43-5.42,5.42v5.38c0,2.99,2.43,5.42,5.42,5.42
					c2.99,0,5.42-2.43,5.42-5.42v-5.38C46.61,14.98,44.18,12.54,41.19,12.54z"
                            />
                            <path
                                className={styles.cls1}
                                d="M41.19,30.54c-3.97,0-7.2-3.23-7.2-7.2v-5.38c0-3.97,3.23-7.2,7.2-7.2s7.2,3.23,7.2,7.2v5.38
					C48.39,27.31,45.16,30.54,41.19,30.54z M41.19,13.14c-2.66,0-4.82,2.16-4.82,4.82v5.38c0,2.66,2.16,4.82,4.82,4.82
					s4.82-2.16,4.82-4.82v-5.38C46.01,15.31,43.85,13.14,41.19,13.14z"
                            />
                        </g>
                    </g>
                    <g>
                        <g>
                            <path
                                className={styles.cls1}
                                d="M32.79,33.54c-0.22,0-0.43-0.12-0.53-0.33c-0.15-0.29-0.02-0.65,0.27-0.79c0.63-0.31,1.31-0.57,2.03-0.77
					l4.69-1.32c0.32-0.09,0.64,0.1,0.73,0.41c0.09,0.32-0.1,0.64-0.41,0.73l-4.69,1.32c-0.64,0.18-1.26,0.41-1.82,0.69
					C32.96,33.52,32.87,33.54,32.79,33.54z"
                            />
                            <path
                                className={styles.cls1}
                                d="M32.79,34.14c-0.46,0-0.87-0.25-1.07-0.66c-0.14-0.29-0.16-0.61-0.06-0.91c0.1-0.3,0.32-0.55,0.6-0.69
					c0.66-0.33,1.38-0.6,2.13-0.81l4.69-1.32c0.64-0.17,1.29,0.19,1.47,0.83c0.09,0.31,0.05,0.63-0.11,0.91
					c-0.16,0.28-0.41,0.48-0.72,0.56l-4.69,1.32c-0.61,0.17-1.19,0.39-1.72,0.65C33.15,34.1,32.97,34.14,32.79,34.14z M32.78,32.94
					C32.78,32.94,32.78,32.94,32.78,32.94C32.78,32.94,32.78,32.94,32.78,32.94z"
                            />
                        </g>
                    </g>
                    <g>
                        <g>
                            <path
                                className={styles.cls1}
                                d="M48.6,46.87h-8.3c-0.33,0-0.59-0.27-0.59-0.59c0-0.33,0.26-0.59,0.59-0.59h8.3c1.92,0,3.49-1.57,3.49-3.49
					v-5.56c0-0.83-0.82-1.65-1.51-2.19c-0.95-0.75-2.09-1.31-3.38-1.67l-4.56-1.28c-0.31-0.09-0.5-0.42-0.41-0.73
					c0.09-0.32,0.42-0.5,0.73-0.41l4.56,1.28c1.45,0.41,2.72,1.04,3.8,1.88c1.3,1.02,1.96,2.07,1.96,3.12v5.56
					C53.28,44.78,51.18,46.87,48.6,46.87z"
                            />
                            <path
                                className={styles.cls1}
                                d="M48.6,47.47h-8.3c-0.66,0-1.19-0.54-1.19-1.19c0-0.66,0.53-1.19,1.19-1.19h8.3c1.59,0,2.89-1.3,2.89-2.89
					v-5.56c0-0.45-0.47-1.08-1.28-1.72c-0.89-0.7-1.96-1.23-3.18-1.57l-4.56-1.28c-0.31-0.09-0.56-0.29-0.72-0.56
					c-0.16-0.28-0.2-0.6-0.11-0.91c0.18-0.63,0.83-1.01,1.47-0.83l4.56,1.28c1.52,0.43,2.87,1.1,4.01,1.99
					c1.45,1.14,2.19,2.35,2.19,3.59v5.56C53.88,45.11,51.51,47.47,48.6,47.47z"
                            />
                        </g>
                    </g>
                    <g>
                        <g>
                            <path
                                className={styles.cls1}
                                d="M39.4,31.49c-0.33,0-0.59-0.27-0.59-0.59v-1.54c0-0.33,0.26-0.59,0.59-0.59c0.33,0,0.59,0.27,0.59,0.59
					v1.54C39.99,31.22,39.73,31.49,39.4,31.49z"
                            />
                            <path
                                className={styles.cls1}
                                d="M39.4,32.09c-0.66,0-1.19-0.53-1.19-1.19v-1.54c0-0.66,0.53-1.19,1.19-1.19c0.66,0,1.19,0.54,1.19,1.19
					v1.54C40.59,31.55,40.06,32.09,39.4,32.09z"
                            />
                        </g>
                    </g>
                    <g>
                        <g>
                            <path
                                className={styles.cls1}
                                d="M42.8,31.53c-0.33,0-0.59-0.27-0.59-0.59v-1.58c0-0.33,0.26-0.59,0.59-0.59c0.33,0,0.59,0.27,0.59,0.59
					v1.58C43.39,31.26,43.13,31.53,42.8,31.53z"
                            />
                            <path
                                className={styles.cls1}
                                d="M42.8,32.13c-0.66,0-1.19-0.54-1.19-1.19v-1.58c0-0.66,0.53-1.19,1.19-1.19c0.66,0,1.19,0.54,1.19,1.19
					v1.58C43.99,31.59,43.46,32.13,42.8,32.13z"
                            />
                        </g>
                    </g>
                    <g>
                        <g>
                            <path
                                className={styles.cls1}
                                d="M41.03,37.76c-2.27,0-4.12-2.43-4.12-5.42c0-0.34,0.02-0.68,0.07-1.01c0.05-0.32,0.34-0.55,0.67-0.5
					c0.32,0.05,0.55,0.35,0.5,0.67c-0.04,0.28-0.06,0.56-0.06,0.84c0,2.34,1.32,4.24,2.94,4.24c1.62,0,2.94-1.9,2.94-4.24
					c0-0.28-0.02-0.57-0.06-0.84c-0.05-0.32,0.18-0.62,0.5-0.67c0.32-0.05,0.62,0.18,0.67,0.5c0.05,0.33,0.07,0.67,0.07,1.01
					C45.15,35.32,43.31,37.76,41.03,37.76z"
                            />
                            <path
                                className={styles.cls1}
                                d="M41.03,38.36c-2.6,0-4.72-2.7-4.72-6.02c0-0.37,0.03-0.73,0.08-1.09c0.09-0.65,0.7-1.11,1.35-1.01
					c0.32,0.04,0.6,0.21,0.79,0.46c0.19,0.26,0.27,0.57,0.23,0.88c-0.04,0.25-0.05,0.5-0.05,0.76c0,1.97,1.07,3.64,2.34,3.64
					c1.27,0,2.34-1.67,2.34-3.64c0-0.25-0.02-0.51-0.05-0.76c-0.05-0.32,0.04-0.63,0.23-0.88c0.19-0.26,0.47-0.42,0.79-0.46
					c0.31-0.04,0.62,0.03,0.88,0.22c0.26,0.19,0.42,0.47,0.47,0.79c0.05,0.36,0.08,0.73,0.08,1.09
					C45.76,35.66,43.64,38.36,41.03,38.36z"
                            />
                        </g>
                    </g>
                    <g>
                        <g>
                            <path
                                className={styles.cls1}
                                d="M43.38,18.63c-0.75,0-1.3-0.19-1.73-0.38c-0.68-0.31-1.09-0.75-1.46-1.13c-0.36-0.38-0.62-0.66-1.06-0.76
					c-0.91-0.21-2.13,0.48-3.52,1.98c-0.22,0.24-0.6,0.25-0.84,0.03c-0.24-0.22-0.25-0.6-0.03-0.84c1.72-1.86,3.28-2.64,4.65-2.33
					c0.79,0.18,1.25,0.67,1.66,1.09c0.32,0.34,0.62,0.66,1.1,0.87c0.8,0.37,2.06,0.6,4.65-0.88c0.28-0.16,0.65-0.06,0.81,0.22
					c0.16,0.28,0.06,0.65-0.22,0.81C45.64,18.32,44.35,18.63,43.38,18.63z"
                            />
                            <path
                                className={styles.cls1}
                                d="M43.38,19.23c-0.71,0-1.34-0.14-1.98-0.44c-0.78-0.36-1.26-0.86-1.64-1.27C39.41,17.16,39.25,17,39,16.94
					c-0.67-0.15-1.74,0.5-2.94,1.8c-0.45,0.48-1.2,0.51-1.69,0.07c-0.48-0.45-0.51-1.2-0.06-1.69c1.87-2.02,3.63-2.87,5.22-2.51
					c0.97,0.22,1.54,0.82,1.96,1.27c0.29,0.31,0.54,0.57,0.91,0.74c0.67,0.31,1.74,0.49,4.1-0.85c0.27-0.16,0.59-0.2,0.9-0.12
					c0.31,0.08,0.57,0.28,0.72,0.56c0.33,0.57,0.13,1.3-0.44,1.63C46.05,18.77,44.64,19.23,43.38,19.23z"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default GetStartedBetterLeads;
